import { graphql } from "~/lib/graphql";

export const externalEmbedFragment = graphql(`
  fragment externalEmbedFragment on ExternalEmbedRecord {
    __typename
    id
    externalVideo {
      url
      provider
      width
      height
      providerUid
    }
    videoCaption
  }
`);
